import { ApolloClient, HttpLink, InMemoryCache, gql } from '@apollo/client';
import fetch from 'cross-fetch';

/**
 * Apollo Client instance
 */
const client = new ApolloClient({
  link: new HttpLink({
    uri: process.env.REACT_APP_EXT_API_URL + 'web/' + process.env.REACT_APP_API_LATEST,
    fetch,
  }),
  cache: new InMemoryCache(),
});

/**
 * Execute a GraphQL query
 * @param {string} queryString - GraphQL query string
 * @param {Object} options - Query options (variables, fetchPolicy, etc.)
 * @returns {Promise<Object>} Query result
 */
export async function queryRequest(queryString, options = {}) {
  const parsedQuery = gql(queryString);
  return await client.query({ query: parsedQuery, ...options });
}

/**
 * Execute a GraphQL mutation
 * @param {string} mutationString - GraphQL mutation string
 * @param {Object} options - Mutation options (variables, update, etc.)
 * @returns {Promise<Object>} Mutation result
 */
export async function mutateRequest(mutationString, options = {}) {
  const parsedMutation = gql(mutationString);
  return await client.mutate({ mutation: parsedMutation, ...options });
}
